<template>
  <v-alert type="success" v-if="msg">
    {{msg}}
  </v-alert>
</template>

<script>
export default {
  name: 'fin-success-msg',
  props: {
    msg: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">


</style>
